export default __webpack_public_path__ + "static/delegator@2x-ce92f1e2bed324491423149b4f64a59e.png";